export default "__VITE_ASSET__a4392ced__"